import React, { ReactNode } from 'react';

import classNames from 'classnames';

import { AlertIcon } from '@anyx/shared-icons';


import { Spinner } from '../../atoms';

interface LoadWrapperProps {
  errorNode?: React.ReactNode;
  loadingTemplate?: React.ReactNode;
  className?: string;
  loading?: boolean;
  error?: boolean;
  loaderId?: string;
  message?: ReactNode;
  children?: React.ReactNode | React.ReactNode[];
}

export const LoadWrapper = ({
  error,
  loading,
  className,
  children,
  loaderId,
  message,
  errorNode,
  loadingTemplate,
}: LoadWrapperProps) => {
  const defaultErrorNode = (
    <div className={className}>
      <div className="flex flex-1 items-center justify-center">
        <AlertIcon className="fill-error" />
      </div>
    </div>
  );

  const defaultLoadingTemplate = (
    <div className={classNames('flex items-center justify-center', className)}>
      <div data-loader-id={loaderId} className="flex flex-1 flex-col items-center gap-2">
        <Spinner />
        {process.env['NODE_ENV'] === 'development' && <div>{message}</div>}
      </div>
    </div>
  );

  const resolvedErrorNode = errorNode ?? defaultErrorNode;
  const resolvedLoadingTemplate = loadingTemplate ?? defaultLoadingTemplate;

  const node = error ? resolvedErrorNode : children;
  return <>{loading ? resolvedLoadingTemplate : node}</>;
};
